import { SystemCode, SourceMarket } from '@tff/types/tff/integrate-flight-service';

export const SYSTEM_CODES: SystemCode[] = ['NDC-AF', 'NDC-KL', 'NDC-SQ', 'NDC-EK', 'NDC-X', 'AMA-NDC-X'];

export const SOURCE_MARKETS: { code: SourceMarket; label: string }[] = [
  { code: 'DE', label: 'Germany' },
  { code: 'SE', label: 'Sweden' },
  { code: 'NO', label: 'Norway' },
  { code: 'DK', label: 'Denmark' },
  { code: 'FI', label: 'Finland' },
  { code: 'IR', label: 'Ireland' },
  { code: 'GB', label: 'Great Britain' },
];
